module.exports = __webpack_public_path__ + "img/共時歷收合.edf99bed.svg";